<template>
  <div class="block md:grid gap-x-lg grid-cols-page mb-4 mb-base">
    <h3 id="overages-title" class="mb-none col-span-full">{{ $t('companySettings.billing.overagesSection.title') }}</h3>
    <hr class="my-sm col-span-full" />
    <p id="overages-info" class="col-span-1 mb-base">{{ $t('companySettings.billing.overagesSection.info') }}</p>
    <div>
      <b class="col-span-1 block mb-base">{{ $t('companySettings.billing.overagesSection.title') }}</b>
      <div class="flex items-center">
        <VCheckbox
          id="overages-switch-button"
          type="checkbox"
          subtype="toggle"
          :disabled="disableOveragesSwitch"
          v-model="overagesEnabled"
          :checked="overagesEnabled"
          data-ec="billing_page"
          data-et="overages_toggle"
        />
        <span id="overages-status" class="ml-base">{{ overageStatus }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';

export default {
  name: 'BillingOverages',
  components: {
    VCheckbox,
  },
  props: {
    company: Object,
    overagesAllowed: Boolean,
  },
  computed: {
    overageStatus() {
      return this.overagesEnabled ? this.$t('functional.enabled') : this.$t('functional.disabled');
    },
    disableOveragesSwitch() {
      return !this.overagesAllowed;
    },
    overagesEnabled: {
      get() {
        return this.company.billing_overage && this.overagesAllowed;
      },
      set(value) {
        this.company.billing_overage = value;
        this.overagesLoading = true;
        this.$store.dispatch('company/UPDATE', this.company).finally(() => { this.overagesLoading = false; });
      },
    },
  },
};

</script>
